module.exports = __webpack_public_path__ + "img/i_soundoff.c0684a7.webp";